import Api from '@/services/Api'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Rbe from '@/data/rbe.json'
import censo from '@/data/censo.json'

const RECURSO = '/assistenciasSociais'
export default {
  buscarVagasAcolhimentoPorSubprefeituraNoUltimoMes,
  buscarVagasAcolhimentoConsolidadoUltimoMes,
  buscarPerfisOcupacoesAgrupadosNoUltimoMes,
  vagasAcolhimentoHistoricoConsolidado,
  vagasAcolhimentoHistoricoPorSubprefeitura,
  vagasAcolhimentoHistoricoPossibilidadesFiltro,
  vagasA,
  rendaBasicaEmergencial,
  censoPopulacaoDeRua,
  censoDeRuaSituacaoPorAgrupamento,
  censoDeRuaSituacaoConsolidado,
  censoDeRuaSituacaoConsolidadoPorIntervaloIdade,
  censoDeRuaSituacaoDetalhado,
}

function buscarVagasAcolhimentoPorSubprefeituraNoUltimoMes () {
  const params = ''
  return Api.get(`${RECURSO}/vagasAcolhimentoPorSubprefeituraNoUltimoMes${MetodosGlobais.createEncodeQuery(params)}`)
};
function buscarVagasAcolhimentoConsolidadoUltimoMes () {
  const params = ''
  return Api.get(`${RECURSO}/vagasAcolhimentoConsolidadoUltimoMes${MetodosGlobais.createEncodeQuery(params)}`)
};
function buscarPerfisOcupacoesAgrupadosNoUltimoMes ({ agrupamento }) {
  let params = { 'agrupamento': agrupamento }
  return Api.get(`${RECURSO}/perfisOcupacoesAgrupadosNoUltimoMes${MetodosGlobais.createEncodeQuery(params)}`)
};
/**
 * @param {Object} agrupamento   => datInicio dataFim idTipoServico idSubprefeitura
 * @returns {Array}
 *   [0] = Consolidado do periodo solicitado
 *   [X] = Cada mês do recorte temporal do mais antigo para o mais recente. Se não hover recorte trará todos os dados disponiveis do mais antigo para o mais recente
 *          Agrupado por outros parametros como idTipoServico e idSubprefeitura
 *
 *    OBS = No Null Safe. Campos nulos correspondem a valores indisponiveis  Dados disponiveis posteriores a 1q/2015
 */
function vagasAcolhimentoHistoricoConsolidado ({ agrupamento }) {
  let params = { 'agrupamento': agrupamento }
  return Api.get(`${RECURSO}/vagasAcolhimentoHistoricoConsolidado${MetodosGlobais.createEncodeQuery(params)}`)
};
/**
 * @param {Object} agrupamento   => datInicio dataFim idTipoServico idSubprefeitura
 * @returns {Array}
 *   [0] = Consolidado do periodo solicitado
 *   [X] = Cada mês do recorte temporal do mais antigo para o mais recente. Se não hover recorte trará todos os dados disponiveis do mais antigo para o mais recente
 *          Agrupado por outros parametros como idTipoServico e idSubprefeitura
 */
function vagasAcolhimentoHistoricoPorSubprefeitura ({ dataInicio = null, dataFim = null, idTipoServico = 1, idSubprefeitura = 0, agrupamento = null }) {
  let params = { 'agrupamento': agrupamento, 'dataInicio': dataInicio, 'dataFim': dataFim, 'idTipoServico': idTipoServico, 'idSubprefeitura': idSubprefeitura }
  return Api.get(`${RECURSO}/vagasAcolhimentoHistoricoPorSubprefeitura${MetodosGlobais.createEncodeQuery(params)}`)
};
/**
 *
 * @param {Object} agrupamento
 */
function vagasAcolhimentoHistoricoPossibilidadesFiltro ({ dataInicio = null, dataFim = null, idTipoServico = 1, idSubprefeitura = 0, agrupamento = null }) {
  let params = { 'agrupamento': agrupamento, 'dataInicio': dataInicio, 'dataFim': dataFim, 'idTipoServico': idTipoServico, 'idSubprefeitura': idSubprefeitura }
  return Api.get(`${RECURSO}/vagasAcolhimentoHistoricoPossibilidadesFiltro${MetodosGlobais.createEncodeQuery(params)}`)
};

function censoDeRuaSituacaoPorAgrupamento ({ agrupamentoGeral = null, agrupamentoRegiao = null }) {
  let params = { 'agrupamentoGeral': agrupamentoGeral, 'agrupamentoRegiao': agrupamentoRegiao }
  return Api.get(`${RECURSO}/censoDeRuaSituacaoPorAgrupamento${MetodosGlobais.createEncodeQuery(params)}`)
};
function censoDeRuaSituacaoConsolidado () {
  return Api.get(`${RECURSO}/censoDeRuaSituacaoConsolidado`)
};
function censoDeRuaSituacaoConsolidadoPorIntervaloIdade ({ idadeMinima = null, idadeMaxima = null }) {
  let params = { 'idadeMinima': idadeMinima, 'idadeMaxima': idadeMaxima }
  return Api.get(`${RECURSO}/censoDeRuaSituacaoConsolidadoPorIntervaloIdade${MetodosGlobais.createEncodeQuery(params)}`)
};
function censoDeRuaSituacaoDetalhado () {
  return Api.get(`${RECURSO}/censoDeRuaSituacaoDetalhado`)
};

function vagasA () {
  return Promise.resolve([])
}

function rendaBasicaEmergencial () {
  return Promise.resolve(Rbe)
};

function censoPopulacaoDeRua () {
  return Promise.resolve(censo)
}
